module.exports = __webpack_public_path__ + "static/media/claudeai.9e170361.svg";